import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAllowedReportGroups } from '../hooks/useReportAccess';
import { DASHBOARD_TAB_META, DashboardTabStrip, visibleDashboardTabs } from './dashboardTabs';

const AnalyticsPage = React.lazy(() => import('./analytics/AnalyticsPage'));

/**
 * /dashboard/overview — the Analytics page as the dashboard's first tab. The
 * strip is the same one DashboardNew renders, so switching tabs feels like one
 * page; the other tabs navigate to their DashboardNew routes.
 */
export default function DashboardOverview() {
  const navigate = useNavigate();
  const allowedReportGroups = useAllowedReportGroups();
  const tabs = visibleDashboardTabs(allowedReportGroups);

  const strip = (
    <DashboardTabStrip
      tabs={tabs}
      active="overview"
      onChange={(key) => {
        const next = DASHBOARD_TAB_META[key];
        if (next && key !== 'overview') navigate(next.path);
      }}
    />
  );

  return (
    <React.Suspense fallback={null}>
      <AnalyticsPage tabs={strip} />
    </React.Suspense>
  );
}
